module.exports = __webpack_public_path__ + "img/number-thumb-18.f50d2b0d.jpg";